import { Car, Users, Ticket, Wifi, ShieldCheck, MapPin, type LucideIcon } from "lucide-react";

export type Affiliate = {
  id: string;
  name: string;
  url: string;
  blurb: string;
  icon: LucideIcon;
};

export const AFFILIATES: Record<string, Affiliate> = {
  klook: {
    id: "klook",
    name: "Klook",
    url: "https://klook.tpx.lv/xh0iaoQu",
    blurb: "Hitta aktiviteter & upplevelser på din destination",
    icon: Ticket,
  },
  kiwitaxi: {
    id: "kiwitaxi",
    name: "Kiwitaxi",
    url: "https://kiwitaxi.tpx.lv/jxNfgNmI",
    blurb: "Boka flygplatstransfer i förväg",
    icon: Car,
  },
  localrent: {
    id: "localrent",
    name: "Localrent",
    url: "https://localrent.tpx.lv/PPbz1Cux",
    blurb: "Hyrbil hos lokala uthyrare",
    icon: MapPin,
  },
  welcome: {
    id: "welcome",
    name: "Welcome Pickups",
    url: "https://tpx.lv/8euYcmUK",
    blurb: "Möt & hämta-service vid ankomst",
    icon: Users,
  },
  saily: {
    id: "saily",
    name: "Saily",
    url: "https://saily.tpx.lv/nfI8gNnH",
    blurb: "eSIM med data för resan",
    icon: Wifi,
  },
  ekta: {
    id: "ekta",
    name: "EKTA",
    url: "https://ektatraveling.tpx.lv/zoVgekg2",
    blurb: "Reseförsäkring inför nästa resa",
    icon: ShieldCheck,
  },
};

export const ALL_AFFILIATES: Affiliate[] = Object.values(AFFILIATES);

// Stable per-seed pick (deterministic hash)
export function pickByHash<T>(seed: string, items: T[]): T {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) | 0;
  return items[Math.abs(h) % items.length];
}

export function randomAffiliate(exclude?: string[]): Affiliate {
  const pool = exclude?.length
    ? ALL_AFFILIATES.filter((a) => !exclude.includes(a.id))
    : ALL_AFFILIATES;
  return pool[Math.floor(Math.random() * pool.length)];
}
